import { useObserver } from 'mobx-react-lite'
import React from 'react'

import { SelectButtonThemed } from '../../../common/Buttons'
import { DeliveryTypeEnum } from '../../../graph/generated'
import { useOrderModel } from '../../../hooks/useOrderModel'
import { TOrderModel } from '../../../models/OrderModel'

interface IProps {
  orderMethod: DeliveryTypeEnum
  onChange(order: TOrderModel): void
}

export const OrderMethodButton: React.FC<IProps> = ({
  orderMethod,
  onChange,
  children,
}) => {
  const orderModel = useOrderModel()
  return useObserver(() => (
    <SelectButtonThemed
      selected={orderModel.orderMethod === orderMethod}
      onClick={() => {
        orderModel.useOrderMethod(orderMethod)
        onChange(orderModel)
      }}
      data-testid={`orderMethod-${orderMethod}`}
      data-testselected={orderModel.orderMethod === orderMethod}
    >
      {children}
    </SelectButtonThemed>
  ))
}
